import { SectionStubDto } from 'models/dtoTypes';

interface SectionMenuItem {
  alias: string;
  path: string;
  label: string;
  lock: boolean;
  color: string;
}

const getColor = (sectionResponseState: string | undefined): string => {
  switch (sectionResponseState) {
    case 'Partial':
      return '#ffe059';
    case 'Completed':
      return '#01820c';
    default:
      return '#cccecc';
  }
};

const generateSectionMenu = (
  sections: SectionStubDto[],
  section: SectionStubDto,
): SectionMenuItem => {
  const { alias = '', label, sectionResponseState } = section;
  return {
    alias,
    path: alias,
    label: label || 'Unknown',
    color: getColor(sectionResponseState),
    lock: false,
  };
};

export const generateSectionMenus = (sections: SectionStubDto[]): SectionMenuItem[] =>
  sections.map((section) => generateSectionMenu(sections, section));

export default function generateSmeMenuList(
  sections: SectionStubDto[],
  t: (key: string) => string,
) {
  return [
    {
      label: t('company-details'),
      icon: 'CompanySvg',
      path: '/questionnaire',
      subItems: generateSectionMenus(sections),
    },
    {
      label: t('esg-ratings'),
      path: '/esg-ratings',
      icon: 'FinanceSvg',
    },
    {
      label: t('my-smart-governance'),
      path: '/smart_governances',
      icon: 'FinanceSvg',
    },
    {
      label: t('my-applications'),
      path: '/wome_applications',
      icon: 'FinanceSvg',
    },
  ];
}
